import { render, staticRenderFns } from "./EditRecruitingProfilePrivacy.vue?vue&type=template&id=570a28ae&scoped=true&"
import script from "./EditRecruitingProfilePrivacy.vue?vue&type=script&lang=ts&"
export * from "./EditRecruitingProfilePrivacy.vue?vue&type=script&lang=ts&"
import style0 from "./EditRecruitingProfilePrivacy.vue?vue&type=style&index=0&id=570a28ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a28ae",
  null
  
)

export default component.exports